import React from 'react';
import ProjectLayout from '../ProjectLayout';
import './ProjectPage.css'; // Custom styles for this project

const VoiceWebAgent = ({ project }) => {
  return (
    <ProjectLayout project={project} className="cot-page">
      <p>
      After working on <a href="https://www.tbench.ai/" target="_blank" rel="noopener noreferrer"> Terminal Bench</a>, I wanted to go deeper on how coding agents actually work. I'd read the fundamental <a href="https://www.anthropic.com/engineering/building-effective-agents" target="_blank" rel="noopener noreferrer"> articles</a> and made smaller agents at Intel, but I wanted to move into state-of-the-art research.
      In this project, I set out to make the best possible Browser Agent I could, and I
      wanted to make it so one could interact with only voice (mostly so I could test some new multimodal models while I was already at it ).
      </p>
      <p>
          To do this, I had a pretty concrete plan:
          <ul>
              <li>Warm up by coding voice input and voice output</li>
              <li>Figure out how people even interact with the browser with Agents</li>
              <li>Iterate fast. Figure out how to make that agent as good as possible</li>

          </ul>
          For step 1, I used one of OpenAI's new transcribe models, which have much better performance than the Whisper Models from a few years ago. For voice output, I used ElevenLabs to just see how those APIs worked as well.
      </p>
      <p>
      To get a good understanding of how to make effective applications with AI, I turned to current research papers.
          <ul>
              <li>I used <a href="https://arxiv.org/abs/2412.05467"
          target="_blank"
          rel="noopener noreferrer"
          >
           BrowserGym
          </a>'s Environment Implementation for my Agent to interact with the browser, I chose this because I think benchmarking against other agents shows me how good my performance is</li>
              <li>I modeled my implementation after <a href="https://arxiv.org/abs/2407.16741"
          target="_blank"
          rel="noopener noreferrer"
          >
           OpenHands
          </a></li>
              <li>I iterated on prompts (this part was really hard)</li>
          </ul>
          The model handles small browsing tasks reliably. Benchmarks coming soon!

      </p>
      <p>
          Visit the links to see more!
      </p>

      <section className="links-section">
        <h3>Project Links</h3>
        <div className="project-links">
            <a href="https://github.com/lanpouthakoun/voice_web_agent/tree/main"
            target="_blank"
            rel="noopener noreferrer"
            >
            View Source Code
            </a>
            <a href="https://www.loom.com/share/069e9393c3054117b9d4d769f60539cc"
                target="_blank"
                rel="noopener noreferrer"
            >
            Watch a Demo!
            </a>
        </div>
      </section>
    </ProjectLayout>
  );
};

export default VoiceWebAgent;
